<template>
  <v-tooltip v-if="false && hover != false"
             bottom>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on"
              size="20"
              :color="''"
              v-text="'mdi-lock'" />
    </template>
    {{$t('servicesystem.common_objects.fallbackterms.locked_field')}}
  </v-tooltip>
</template>



<script>
export default {
  name: "LockedWarning",
  props: ["hover"],

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {},
};
</script>